/*
 * @Author: hanchunxuan 1627047609@qq.com
 * @Date: 2023-10-08 08:46:05
 * @LastEditors: hanchunxuan 1627047609@qq.com
 * @LastEditTime: 2023-10-13 14:50:53
 * @FilePath: \1008\zonghoutai-front\src\main.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import http from './api/http'
import './axios/request.js'
import './assets/reset.css'
import './assets/iconfont.css'
import './assets/elementInfo'
import dataV from '@jiaminghi/data-view'
import HappyScroll from 'vue-happy-scroll'
import echartsGL from 'echarts-gl' // 引入echarts
Vue.prototype.$echartsGL = echartsGL

import '../node_modules/echarts/map/js/world.js' // 引入世界地图
// 引入css
import 'vue-happy-scroll/docs/happy-scroll.css'
Vue.use(HappyScroll)


Vue.use(dataV)

// let userId =JSON.parse(localStorage.getItem('userInfo')).userId|| ''
// console.log('AppuserId',userId);

Vue.config.productionTip = false
Vue.prototype.$http=http



new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
